var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9322 3.67184C13.747 2.70009 14.2963 1.34664 14.146 0C12.9717 0.0460004 11.5511 0.771826 10.7091 1.74242C9.95306 2.60377 9.29305 3.98007 9.47049 5.30027C10.7803 5.40031 12.1173 4.64472 12.9322 3.67184ZM15.8695 12.2189C15.9022 15.6999 18.9661 16.8579 19 16.8728C18.9751 16.9545 18.5106 18.5228 17.3861 20.1443C16.4131 21.545 15.4038 22.94 13.8137 22.9699C12.2518 22.9986 11.7489 22.0568 9.96211 22.0568C8.17645 22.0568 7.61815 22.9399 6.1399 22.9985C4.60515 23.0549 3.43543 21.4831 2.45558 20.087C0.450674 17.2316 -1.08069 12.0177 0.976201 8.49874C1.99787 6.75189 3.82307 5.64401 5.80537 5.61641C7.31188 5.58766 8.73475 6.61593 9.65583 6.61593C10.5769 6.61593 12.3061 5.37968 14.1234 5.56138C14.884 5.59243 17.02 5.86374 18.3908 7.84287C18.2801 7.91072 15.8423 9.30938 15.8695 12.2189Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIconSmall);
export default __webpack_public_path__ + "static/media/AppleIconSmall.d3fe4a40dec6e38718c030a689cb6d4f.svg";
export { ForwardRef as ReactComponent };